import React, { PropsWithChildren, ReactNode } from "react";
import Column from "@amzn/meridian/column";
import "./scrollableSection.scss";

interface ScrollableSectionProps extends PropsWithChildren {
  spacingInset?: string;
}

const ScrollableSection = ({ children, spacingInset = "0 0 400 0" }: ScrollableSectionProps) => {
  return (
    <Column
      spacing="400"
      spacingInset={spacingInset}
      height="85vh"
      heights="fit"
      overflowY="auto"
      overflowX="hidden"
    >
      {children}
    </Column>
  );
};

export default ScrollableSection;
